import { atom } from "recoil";

// TODO 모달 높이 전역 상태, dev 머지 후 삭제 가능
export const taskDetailHeightState = atom({
  key: "taskDetailHeightState",
  default: 600,
});
